import styled from 'styled-components';
import { theme } from '../../../theme';
import { color, space } from 'styled-system';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';

const Wrapper = styled.div`
  ${space};
  background-color: ${props => props.theme.colors.cardBackground};
  border-radius: 2px;
  box-shadow: 0 10px 10px -6px rgba(214, 219, 230, 0.6);
  margin-bottom: ${theme.space[2]}px;
  width: 100%;

  section {
    font-size: ${theme.fontSize[0]};
    padding: ${theme.space[4]}px ${theme.space[3]}px ${theme.space[3]}px;
  }

  .kdpgsd {
    overflow: visible !important;
  }
`;

export const AccordionHeaderLine = styled.div<StyledSystemProps>`
  ${color};
  display: inline;
  background-color: ${props => props.theme.colors.primary};
  border-radius: 2px;
  height: ${theme.space[1] / 2}px;
  position: absolute;
  width: 100%;
  top: 12px;
`;

export const AccordionLeftHeaderWrapper = styled.div<StyledSystemProps>`
  ${color};
  width: 100%;
  display: inline;
`;

export const AccordionHeader = styled.header<StyledSystemProps>`
  ${color};
  align-items: center;
  color: ${props => props.theme.colors.text};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding-right: ${theme.space[3]}px;

  .c-icon,
  .c-icon > svg {
    height: ${theme.space[4]}px;
    width: ${theme.space[4]}px;
  }

  .c-icon-small,
  .c-icon-small > svg {
    height: ${theme.space[3]}px;
    width: ${theme.space[3]}px;
  }

  &.-open {
    .c-icon {
      transform: rotate(180deg);
      transform-origin: 50% 50%;
    }
  }
`;

type BodyProps = {
  visibility?: string;
};

export const AccordionBody = styled.section<BodyProps>`
  visibility: ${props => (props.visibility ? 'visible' : 'hidden')};
  opacity: ${props => (props.visibility ? '1' : '0')};
  height: ${props => (props.visibility ? 'auto' : '0')};
  overflow: ${props => (props.visibility ? 'visible' : 'hidden')};
  transition: max-height 0.3s ease, visibility 0.3s ease;
  padding: ${props => (props.visibility ? '20px 15px 15px' : '0px')} !important;
`;

AccordionHeader.defaultProps = {
  bg: 'textDefault',
  color: 'white',
};

export default Wrapper;
